<div class="d-inline-flex" style="font-size: 30px;" (click)="back()">
  <ion-icon name="arrow-back-outline"></ion-icon>
</div>